/**
 * @see config/pncHosts.js — Node(server·proxy) 와 동일 값 유지
 * API(pncapi.kr) 와 이미지 서버(pncapi.kr:88)는 별도 호스트
 */
export const PNC_API_ORIGIN = "https://pncapi.kr";
export const PNC_IMAGE_SERVER_ORIGIN = "https://www.pncapi.kr:88";
export const PNC_IMAGE_DEV_MIRROR_ORIGIN = "http://www.pncoffice.net";
